export const AppNav = {
  Root: "/",
  Auth: "auth",
  Main: "main",
  Connect: "connect",
  History: "history",
  HistoryPool: "history-pool",
  FeePlan: "fee-plan",
  Monitoring: "monitoring",
  Payouts: "payouts",
  // Rewards: "rewards",
  Settings: "settings",
  About: "about",
  AboutPublic: "about-public",
  Terms: "terms",
  Users: "users",
  CreateUser: "create-user",
  ProfitSettings: "profit-settings",
  PpsState: "pool-config",
};
